import React from "react";
declare global {
  interface Window {
      ddo: any;
  }
}
export type AnalyticsEventProps = {
  eventCode: string;
  eventAction: string;
  additionalData?: Record<string, unknown>
};

const cachedEvents: AnalyticsEventProps[] = [];
declare const ssaf: { sendData: (arg0: Record<string, unknown>) => void; };

export const AnalyticsEvent = ({ eventCode, eventAction, additionalData }: AnalyticsEventProps) => {
  let dataObj = {
    "eventAction": eventAction,
    "eventCode": eventCode,
    "additionalData": additionalData
  }
  if (typeof window.ddo === 'undefined') {
    if (cachedEvents.length === 0) {
      window.addEventListener('DM_DOC_READY', (e) => {
        for (const dtmAnalyticsEvent of cachedEvents) {
          ssaf.sendData(dtmAnalyticsEvent);
        }
        cachedEvents.length = 0;
      });
    }
    cachedEvents.push(dataObj);
  }
  else {
    if (cachedEvents.length>0) {
        for (const dtmAnalyticsEvent of cachedEvents) {
            ssaf.sendData(dtmAnalyticsEvent);
        }
        cachedEvents.length = 0;
    }
    ssaf.sendData(dataObj);
}
};

export default AnalyticsEvent;